// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__2bojM","buttons":"styles_buttons__dNAbw"};